import { useEffect, useState } from "react";
import { t } from "@/i18n-js/instance";
import type { CoursesLesson } from "@/react/types/CoursesLesson";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

interface ContentProps {
  navigateToNextLesson: (lesson?: any) => any;
  nextLesson: CoursesLesson;
  removeModal: () => any;
}
export const Content = ({
  navigateToNextLesson,
  nextLesson,
  removeModal,
}: ContentProps) => {
  const [countdown, setCountdown] = useState(10);

  const handleContinue = () => {
    removeModal();
    navigateToNextLesson(nextLesson);
  };

  useEffect(() => {
    let timeout: any;

    if (countdown > 0) {
      timeout = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else {
      void handleContinue();
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [countdown]);

  return (
    <div className="flex w-full flex-col px-8 pb-5 pt-10 text-center">
      <div className="mb-2">
        <Typography.LabelMd color="text-default">
          {t("courses.view_lesson.autocomplete_lesson_modal.next_lesson")}
        </Typography.LabelMd>
      </div>
      <div className="mb-6 line-clamp-2">
        <Typography.TitleMd>{nextLesson?.name}</Typography.TitleMd>
      </div>
      <div className="mb-10">
        <Typography.LabelMd color="text-default">
          {t("courses.view_lesson.autocomplete_lesson_modal.will_begin_in", {
            seconds: countdown,
          })}
        </Typography.LabelMd>
      </div>
      <Button variant="circle" className="mb-3" onClick={handleContinue}>
        {t("continue")}
      </Button>
      <Button variant="text" onClick={removeModal}>
        {t("cancel")}
      </Button>
    </div>
  );
};
